
import PageTitle from '@/UI/components/common/PageTitle.vue';
import { mixins } from 'vue-class-component';
import { SimpleProxyForm } from '@/UI/components/Helpers/SimpleProxyForm';
import BaseDataForm from '@/UI/components/Helpers/BaseForm/BaseDataForm.vue';
import { Component } from 'vue-property-decorator';
import { Button, Menu, List, Row } from 'ant-design-vue';
@Component({
    components: {
        PageTitle,
        BaseDataForm,
        'a-button': Button,
        'a-menu-item': Menu.Item,
        'a-list-item': List.Item,
        'a-list-item-meta': List.Item.Meta,

        'a-row': Row,
    },
})
export default class FinanceDocuments extends mixins(SimpleProxyForm) {}
